import { Platform } from 'react-native';

/**
 * Agapē Design System — Layout Constants
 *
 * Single source of truth for all layout dimensions.
 * Every section/container MUST use these values.
 */

export const layout = {
    /** Maximum content width for all sections */
    maxWidth: '100%' as const,

    /** Horizontal padding: consistent 12px on all platforms.
     *  Desktop sections override inline with larger values (40-48px). */
    paddingH: 12,

    /** Standard vertical section rhythm */
    sectionPaddingY: Platform.OS === 'web' ? 80 : 40,
    sectionPaddingYCompact: Platform.OS === 'web' ? 48 : 24,
    sectionPaddingYLarge: Platform.OS === 'web' ? 120 : 60,

    /** Desktop breakpoint */
    breakpoint: {
        mobile: 480,
        tablet: 768,
        desktop: 1024,
        wide: 1280,
    },

    /** Header height tokens */
    headerHeight: 90,
    headerHeightScrolled: 80,

    /** Inter-section gap (vertical space between sections) */
    sectionGap: 0,
} as const;

/** Container style preset — use directly in StyleSheet.create() */
export const containerStyle = {
    maxWidth: layout.maxWidth,
    marginHorizontal: 'auto' as const,
    paddingHorizontal: layout.paddingH,
    width: '100%' as const,
};

export type LayoutKey = keyof typeof layout;
